/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .no-frame .form-legend{display:none}[_nghost-%COMP%]     .no-frame .form-fieldset{padding:0;border:none}[_nghost-%COMP%]     .no-frame .form-action{height:100%}[_nghost-%COMP%]     .form-actions form-button:first-child button{margin-left:0}.second-step[_ngcontent-%COMP%]     .column-items .mat-form-field-infix{display:flex;flex-direction:column}.second-step[_ngcontent-%COMP%]     .column-items .mat-form-field-label-wrapper{width:100%;max-width:100%;flex-basis:auto;margin-bottom:.9375vw;margin-right:0}"];
export { styles as styles };
